<template lang="pug">
    div
        div.email(v-for="(item, key) in emails" :key="key")

            // Email subject
            div {{ item.subject }}
            div

                // Edit business button
                button-component(:action="() => setEmail({ index: key, data: item })" color="white" icon="edit")

                // Delete business button
                button-component(:action="() => deleteEmail(key)" color="white" icon="delete")

</template>

<script>
    import ButtonIcon from '~components/ButtonIcon';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon
        },
        computed: {
            ...mapGetters('programs', ['emails'])
        },
        methods: {
            ...mapActions('programs', ['deleteEmail']),
            ...mapActions('emails', ['setEmail'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .email
        display: flex
        align-items: center
        justify-content: space-between
        padding: 5px 15px
        margin: 5px 0
        border: 1px solid rgba($theme.white, 0.5)
        background: $theme.primary
</style>
